import Badge from '@/components/ui/Badge'
import type { PaymentMethod, PaymentStatus } from '@/types'

const tones = {
  pending: 'warning',
  unpaid: 'danger',
  paid: 'success',
  refund_due: 'danger',
  refunded: 'neutral',
  void: 'neutral',
} as const

export const paymentStatusLabels: Record<PaymentStatus, string> = {
  pending: 'Awaiting payment',
  unpaid: 'Unpaid',
  paid: 'Paid',
  refund_due: 'Refund due',
  refunded: 'Refunded',
  void: 'Void',
}

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  wallet: 'Wallet',
  gateway: 'Online payment',
  offline: 'Offline',
}

export const paymentStatusOptions = (Object.keys(paymentStatusLabels) as PaymentStatus[]).map((value) => ({
  value,
  label: paymentStatusLabels[value],
}))

/**
 * Where the money on an order stands, separate from where the order is in
 * production. Always a word as well as a colour.
 */
export default function PaymentBadge({ status, className }: { status?: PaymentStatus | null; className?: string }) {
  if (!status) return null

  return (
    <Badge tone={tones[status]} className={className}>
      {paymentStatusLabels[status]}
    </Badge>
  )
}
